module.exports = __webpack_public_path__ + "img/water-drop-green.dfb62c39.svg";